import i18n from 'live/services/i18n'

export const groupsMock = [
    {
        groupName: 'Group 11111111111111111111111111111111111111111111111111111111111111',
        groupDescription:
            '1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec ipsum velit vulputate aliquet at. Tempus semper quisque integer commodo leo tellus feugiat nunc quis.',
        alarmUsers: [{ groupUserLiveId: 2 }],
        groupUsersLiveId: 'Zibão',
        alarmBowties: []
    },
    {
        groupName: 'Group 2',
        groupDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec ipsum velit vulputate aliquet at. Tempus semper quisque integer commodo leo tellus feugiat nunc quis.',
        alarmUsers: [{ groupUserLiveId: 2 }],
        groupUsersLiveId: 'Zibão',
        alarmBowties: []
    },
    {
        groupName: 'Group 3',
        groupDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec ipsum velit vulputate aliquet at. Tempus semper quisque integer commodo leo tellus feugiat nunc quis.',
        alarmUsers: [{ groupUserLiveId: 2 }],
        groupUsersLiveId: 'Zibão',
        alarmBowties: []
    },
    {
        groupName: 'Group 4',
        groupDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec ipsum velit vulputate aliquet at. Tempus semper quisque integer commodo leo tellus feugiat nunc quis.',
        alarmUsers: [{ groupUserLiveId: 2 }],
        groupUsersLiveId: 'Zibão',
        alarmBowties: []
    }
]

export const usersMock = [
    {
        id: 1,
        name: 'Anderson'
    },
    {
        id: 2,
        name: 'Miqueias'
    },
    {
        id: 3,
        name: 'Péricles'
    },
    {
        id: 4,
        name: 'MC Marcinho'
    },
    {
        id: 5,
        name: 'Tom Brady'
    },
    {
        id: 6,
        name: 'Micheliton'
    },
    {
        id: 7,
        name: 'Jose'
    },
    {
        id: 8,
        name: 'Maria'
    },
    {
        id: 9,
        name: 'Joaquim'
    }
]

export const severityMock = [
    { id: 1, name: i18n('Information') },
    { id: 2, name: i18n('Warning') },
    { id: 3, name: i18n('Error') },
    { id: 4, name: i18n('Fatal') }
]
